import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API } from "../../constants/api";
import HttpService from "../../services/HttpService";
import { RootState } from "../store";

export const ApiCallWithLoader = createAsyncThunk(
  "loading",
  async (requestDetails: any, { rejectWithValue }) => {
    try {
      const response = await HttpService.instance.callAPI(
        requestDetails?.url,
        requestDetails?.method,
        requestDetails?.requestData,
        requestDetails?.callType
      );
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const StaticContentCallWithLoader = createAsyncThunk(
  "loading",
  async (requestDetails: any, { rejectWithValue }) => {
    try {
      const response = await HttpService.instance.callStaticResource(
        requestDetails?.url
      );
      return response;
    } catch (error) {
      // console.log("Error", error);
      throw rejectWithValue(error);
    }
  }
);

export const LaunchTokenApiCallWithLoader = createAsyncThunk(
  "loading",
  async (requestDetails: any, { rejectWithValue }) => {
    try {
      const response = await HttpService.instance.callLaunchTokenAPI(
        requestDetails?.url,
        requestDetails?.method,
        requestDetails?.requestData
      );
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const initialState: any = {
  loading: false,
  data: null,
  error: null,
  isError: false,
};

export const LoaderSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    errorUpdate: (state, action: PayloadAction<any>) => {
      state.isError = true;
      state.error = action.payload.error;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(ApiCallWithLoader.pending, state => {
        state.loading = true;
      })
      .addCase(ApiCallWithLoader.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(ApiCallWithLoader.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isError = true;
      });
  },
});

export const { errorUpdate } = LoaderSlice.actions;
export const LoaderState = (state: RootState) => state.loader;

export default LoaderSlice.reducer;
